import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import { Button } from '../../shared/components/Buttons';

const ErrorPage403 = () => {
  const navigate = useNavigate();
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    fetch('/assets/lottie/403LottieFile.json')
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-8 bg-white rounded-[4px] shadow-[0px_2px_4px_0px_#00000014]">
      {animationData ? (
        <Lottie
          animationData={animationData}
          loop={false}
          style={{ width: '298px', height: '235px' }}
        />
      ) : (
        <div style={{ width: '298px', height: '235px' }} />
      )}
      <div className="flex flex-col items-center gap-2 text-center">
        <p className="text-titleMedium text-on-surface-variant font-semibold">
          403 – Access Denied
        </p>
        <p className="text-bodyLarge text-on-surface-variant max-w-sm">
          Looks like this page is restricted. If you think you should have
          access, try contacting your admin.
        </p>
      </div>
      <Button
        className="cursor-pointer"
        label="Go to Dashboard"
        onClick={() => navigate('/')}
      />
    </div>
  );
};

export default ErrorPage403;
